const actions = {
    setTerminal: ({ commit }, terminal) => { //设置终端
        return commit('SET_TERMINAL', terminal)
    },
    setLoginName: ({ commit }, loginName) => { //存储用户登录名
        return commit('SET_LOGINNAME', loginName)
    },
    setDataInfo: ({ commit }, dataInfo) => { //数据详情
        return commit('SET_DATAINFO', dataInfo)
    },
    setDataListTable: ({ commit }, dataListTable) => { //数据列表
        return commit('SET_DATALISTTABLE', dataListTable)
    },
    setLanguage: ({ commit }, language) => { //语言
        return commit('SET_LANGUAGE', language)
    },
    setCategories: ({ commit }, Categories) => { //标签
        return commit('SET_CATEGORIES', Categories)
    },
    setSortVal: ({ commit }, sortVal) => { //排序
        return commit('SET_SORTVAL', sortVal)
    },
    setToken: ({ commit }, token) => { //排序
        return commit('SET_TOKEN', token)
    },
    


}
export default actions